const imageRatio = [3, 2];
const getWidth = (ratio, height) => (ratio[0] * height) / ratio[1];
const height = 448;

export default {
  ratio: imageRatio,
  width: getWidth(imageRatio, height),
  height,
};
